import { Spinner } from "@blueprintjs/core";

import { Button } from "@/components/ui/button";
import {
  ShareGroup,
  ShareNotification,
  ShareUser,
} from "@/components/ui/sharing";

interface AddPermissionsViewProps {
  selectedUsers: ShareUser[];
  selectedGroups?: ShareGroup[];
  isNotified: boolean;
  message: string;
  onNotificationChange: (isNotified: boolean) => void;
  onMessageChange: (message: string) => void;
  onShare: () => void;
  onCancel: () => void;
  loading: boolean;
}

/**
 * View for adding new permissions (users/groups)
 * Used by ResourceShareModal and RoleplaySessionShareModal
 */
export function AddPermissionsView({
  selectedUsers,
  selectedGroups = [],
  isNotified,
  message,
  onNotificationChange,
  onMessageChange,
  onShare,
  onCancel,
  loading,
}: AddPermissionsViewProps) {
  const hasSelections = selectedUsers.length > 0 || selectedGroups.length > 0;
  const primaryButtonText = isNotified ? "Send" : "Share";

  return (
    <>
      {hasSelections && (
        <ShareNotification
          isNotified={isNotified}
          message={message}
          onIsNotifiedChange={onNotificationChange}
          onMessageChange={onMessageChange}
        />
      )}

      <div className="flex justify-end gap-4 mt-4">
        <Button variant="minimal" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          onClick={onShare}
          disabled={loading || !hasSelections}
          intent="primary"
          className="px-12"
        >
          {loading && <Spinner size={20} />}
          {primaryButtonText}
        </Button>
      </div>
    </>
  );
}
